// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_quoter_src_app_features_cetelem-external-quotes_cetelem-external-quotes_module_ts":"70b33960b1fcf785","projects_quoter_src_app_features_quotation_quotation_module_ts":"93d14c83ff6cded7"}[chunkId] + ".js";
};